import { render, staticRenderFns } from "./goodsClass.vue?vue&type=template&id=1a8b1b22&"
import script from "./goodsClass.vue?vue&type=script&lang=js&"
export * from "./goodsClass.vue?vue&type=script&lang=js&"
import style0 from "./goodsClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports